module.exports = __webpack_public_path__ + "static/img/nodata_share_dialog.ec0bb10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/hjwq/anniversary/nodata_share_dialog.png
// module id = 5PpF
// module chunks = 1